import { focusElement } from 'platform/utilities/ui';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { CONTACTS } from '../../utils/imports';
import PdfDownloadLink from '../PdfDownloadLink';

const SubmissionErrorAlert = ({ form: formConfig }) => {
  useEffect(() => focusElement('h2', {}, 'va-alert[status="error"]'), []);

  return (
    <>
      <div className="vads-u-margin-y--4">
        <va-alert status="error">
          <h2 slot="headline">We didn’t receive your online application</h2>
          <p>We’re sorry. Something went wrong on our end. Try again later.</p>
        </va-alert>
      </div>
      <va-card background>
        <h3 className="vads-u-margin-y--0">Other ways to apply</h3>
        <ul>
          <li>
            Call us at <va-telephone contact={CONTACTS['222_VETS']} />, Monday
            through Friday, 8:00 a.m. to 8:00 p.m.{' '}
            <dfn>
              <abbr title="Eastern Time">ET</abbr>
            </dfn>
            {', '}
            <strong>or</strong>
          </li>
          <li>
            Mail us an application, <strong>or</strong>
          </li>
          <li>
            Bring your application in person to your nearest VA health facility.
          </li>
        </ul>
        <p>
          <va-link
            href="/health-care/how-to-apply/#you-can-also-apply-in-any-of-t"
            text="Learn more about how to apply by mail or in person"
          />
        </p>
        <PdfDownloadLink formConfig={formConfig} />
      </va-card>
    </>
  );
};

SubmissionErrorAlert.propTypes = {
  form: PropTypes.object,
};

export default SubmissionErrorAlert;
